/**
 * Abstract representation of a clock used to obtain the current time.
 */
export abstract class Clock {
    abstract now(): Date;
}